export default __webpack_public_path__ + "static/media/laundry1-beforeA-1920w.d8a20b02.png";